export const ptBR = {
    common: {
        actions: 'Ações',
        add: 'Adicionar',
        cancel: 'Cancelar',
        close: 'Fechar',
        confirm: 'Confirmar',
        delete: 'Excluir',
        edit: 'Editar',
        save: 'Salvar',
        search: 'Buscar',
        loading: 'Carregando...',
        noData: 'Sem dados encontrados',
        required: 'Obrigatório',
    },
    auth: {
        login: 'Entrar',
        logout: 'Sair',
        email: 'E-mail',
        password: 'Senha',
    },
    components: {
        grid: {
            filters: 'Filtros',
            activeFilters: 'Filtros ativos',
            addFilter: 'Adicionar filtro',
            column: 'Coluna',
            operator: 'Operador',
            value: 'Valor',
            clearAll: 'Limpar todos',
            close: 'Fechar',
            noData: 'Sem dados encontrados',
            actions: 'Ações',
            delete: 'Excluir',
            showAll: 'Mostrar todas',
            hideAll: 'Ocultar todas',
            columnsVisible: '{visible} de {total} colunas visíveis',
            columns: 'Colunas',
            density: 'Densidade',
            export: 'Exportar',
            manageColumns: 'Gerenciar Colunas',
        },
        dialog: {
            title: 'Diálogo',
            selectIcon: 'Selecionar Ícone',
            close: 'Fechar',
            confirm: 'Confirmar',
            cancel: 'Cancelar',
        },
        iconPicker: {
            searchPlaceholder: 'Buscar ícone...',
        }
    },
    validation: {
        requiredField: 'Campo obrigatório',
        invalidEmail: 'E-mail inválido',
    },
    settings: {
        title: 'Configurações',
        appearance: {
            title: 'Aparência',
            theme: 'Tema',
            light: 'Claro',
            dark: 'Escuro',
            system: 'Sistema',
        },
        language: {
            title: 'Idioma',
            label: 'Idioma',
            portuguese: 'Português',
            english: 'Inglês',
        },
        about: {
            title: 'Sobre',
            version: 'Versão',
            developedBy: 'Desenvolvido por',
        },
    },
    // Mobile app shell only (request 0158 §7) — telas de módulo de negócio ainda não existem.
    mobile: {
        login: {
            subtitle: 'Acesse sua conta SysColect.',
        },
        resetPassword: {
            title: 'Recuperar senha',
            subtitle: 'Informe seu e-mail e enviaremos um link para redefinir sua senha.',
            backToLogin: 'Voltar para o login',
            sent: 'Se o e-mail existir, enviamos um link para redefinir sua senha.',
            sendLink: 'Enviar link',
            genericError: 'Não foi possível enviar o link. Verifique o e-mail e tente novamente.',
        },
        authErrors: {
            invalidCredentials: 'Credenciais inválidas. Verifique seu e-mail e senha.',
            networkError: 'Sem conexão. Verifique a internet e tente novamente.',
            loginFailed: 'Falha no login. Tente novamente em instantes.',
        },
        workspace: {
            emptyTitle: 'Nenhum módulo habilitado para o aplicativo',
            emptyDescription: 'Nenhum dos módulos desta organização tem tela no aplicativo. Fale com um administrador para liberar módulos para o mobile.',
        },
        group: {
            empty: 'Nenhum item neste grupo',
        },
        module: {
            // Intencionalmente igual nas duas línguas (request 0158 §7): é diagnóstico de cadastro
            // para o admin, não texto de produto — o texto exato ajuda na busca por quem for corrigir
            // o catálogo, então não varia com o idioma do usuário.
            missingTitle: 'Módulo sem tela no aplicativo',
            missingDescription: 'O slug "{{slug}}" está marcado para a plataforma mobile, mas não tem uma tela nativa cadastrada. Isso é um problema de cadastro do módulo, não do aparelho.',
        },
        noOrganization: {
            title: 'Nenhuma organização encontrada',
            description: 'Sua conta não está associada a nenhuma organização ativa. Entre em contato com um administrador para obter acesso.',
            signOutWithEmail: 'Sair ({{email}})',
        },
        userSheet: {
            title: 'Conta',
            organization: 'Organização',
            profile: 'Perfil',
            noValue: '—',
        },
        sessionSelectors: {
            current: 'Atual',
            noProfiles: 'Nenhum perfil disponível nesta organização.',
        },
        drawer: {
            workspace: 'Área de trabalho',
            openMenu: 'Abrir menu',
        },
        privacyPolicy: 'Política de Privacidade',
        userMenuButton: 'Abrir menu do usuário',
        configGate: {
            loading: 'Carregando configurações…',
            errorTitle: 'Não foi possível carregar configurações.',
            retry: 'Tentar de novo',
        },
        session: {
            resolving: 'Carregando sua organização…',
        },
        status: {
            title: 'Status',
            systemApiTitle: 'System API',
            systemApiDescription: 'Conexão obrigatória — sessão ativa e troca de organização/perfil notificada em tempo real.',
            monitorTitle: 'Monitor',
            monitorDescription: 'Conexão opcional, só para diagnóstico pontual — desligada por padrão.',
            appTitle: 'Aplicativo',
            version: 'Versão',
            platform: 'Plataforma',
            sessionTitle: 'Sessão',
            sessionDescription: 'Recriada a cada abertura do app (limitação conhecida). Se o suporte pedir o id da sessão, é este.',
            copy: 'Copiar',
            connectMonitor: 'Conectar monitor',
            markDisconnected: 'Marcar como desconectado',
            notConfigured: 'não configurado',
            origin: 'Origem: {{source}}',
            connecting: 'Conectando',
            connected: 'Conectado',
            closing: 'Encerrando',
            disconnected: 'Desconectado',
            error: 'Erro',
        },
        settings: {
            aboutTitle: 'Sobre',
            appearanceDescription: 'Tema da interface (salvo na sua conta).',
            languageDescription: 'Idioma da interface (salvo na sua conta).',
            // Endônimos — mostrados no próprio idioma, não traduzidos, igual a qualquer seletor de
            // idioma comum (o app não mostra "Inglês" quando está em português, mostra "English").
            portugueseLabel: 'Português',
            englishLabel: 'English',
            scanTitle: 'Leitura',
            scanDescription: 'Coletor com leitor físico: desliga o teclado na tela.',
            scanWedgeLabel: 'Coletor (leitor físico)',
            scanManualLabel: 'Celular (digitação ou câmera)',
            notificationsTitle: 'Notificações',
            notificationsDescription: 'Push neste aparelho (salvo na sua conta).',
            notificationsMaster: 'Receber notificações no celular',
            notificationsPermissionGranted: 'Permissão concedida.',
            notificationsPermissionDenied: 'Permissão negada — libere nas configurações do Android.',
            notificationsPermissionUndetermined: 'Permissão ainda não pedida.',
            notificationsOpenSettings: 'Abrir configurações do Android',
            notificationsCategories: 'Categorias',
            notificationsOrgLocked: 'Definido pela organização',
            notificationsFooter: 'As notificações continuam aparecendo no sino do app.',
        },
        notifications: {
            title: 'Notificações',
            empty: 'Nenhuma notificação',
            filterUnread: 'Não lidas',
            filterAll: 'Todas',
            markAllRead: 'Marcar todas como lidas',
            loadMore: 'Carregar mais',
            archive: 'Arquivar',
        },
        errorBoundary: {
            title: 'Algo deu errado.',
            description: 'O aplicativo encontrou um erro inesperado.',
            retry: 'Tentar de novo',
        },
        // Request 0159 — serviço de leitura, comum a qualquer campo que aceite código de barras.
        scan: {
            openCamera: 'Abrir câmera',
            close: 'Fechar',
            permissionDenied: 'Permissão de câmera negada. Você ainda pode digitar o código.',
            openSettings: 'Abrir ajustes',
        },
        // Request 0159 — coletor WMS (fila + execução de tarefas de armazém).
        warehouseOperator: {
            title: 'Executar tarefas',
            description: 'Fila dirigida — pegue uma tarefa e siga o roteiro passo a passo.',
            refresh: 'Atualizar fila',
            myTasksTitle: 'Continuar',
            availableTasksTitle: 'Disponíveis',
            continueAction: 'Continuar',
            claimAction: 'Pegar',
            emptyTitle: 'Nenhuma tarefa na fila',
            loadingQueue: 'Carregando fila…',
            lineProgress: 'Linha {{current}} de {{total}}',
            pause: 'Pausar',
            resume: 'Retomar',
            release: 'Devolver tarefa',
            skipLine: 'Adiar linha',
            noLines: 'Tarefa sem linhas.',
            taskCompleteTitle: 'Tarefa concluída',
            backToQueue: 'Voltar para a fila',
            completionLines: '{{count}} linhas',
            completionLinesOne: '1 linha',
            deferredRemaining: 'Restam {{count}} linhas adiadas.',
            deferredRemainingOne: 'Resta 1 linha adiada.',
            resumeDeferred: 'Retomar pendências',
            finishWithDeferred: 'Concluir com pendências',
            invalidQuantity: 'Informe um número maior ou igual a zero.',
            allDone: 'Roteiro concluído.',
            retry: 'Tentar de novo',
            unknownStepKind: 'Passo "{{kind}}" não tem tela neste app — avise o suporte.',
            scanHuLabel: 'Código do volume',
            scanAddressLabel: 'Código do endereço',
            confirmAction: 'Confirmar',
            expectedQuantity: 'esperado {{value}}',
            operatorNoteTitle: 'Observação ao operador',
            fieldProduct: 'Produto',
            fieldVariant: 'Variante',
            fieldLot: 'Lote',
            fieldVolume: 'Volume',
            fieldLocation: 'Local',
            fieldAddress: 'Endereço',
            listProgress: '{{informed}} de {{total}} informadas',
            quantityPromptTitle: 'Informar quantidade',
            quantityPromptNext: 'Próximo',
            finishCheck: 'Concluir conferência',
            finishCount: 'Concluir contagem',
            missingQuantities: 'Informe a quantidade de todas as linhas antes de concluir.',
            partialFailure: '{{count}} linhas não foram gravadas. Corrija e conclua novamente.',
            retryFailed: 'Tentar novamente ({{count}})',
            reloadTask: 'Recarregar tarefa',
            // Request 0340 — informar volumes no coletor
            volumes: {
                openButton: 'Volumes',
                noneEntered: 'Sem volumes informados',
                title: 'Volumes — {{product}}',
                expected: 'Previsto: {{value}}',
                expectedBoth: 'Previsto: {{base}} ({{typed}})',
                informIn: 'Informar em',
                standard: 'Padrão',
                extras: 'Diferentes do padrão',
                volumesField: 'Volumes',
                weightEachLabel: 'Peso de cada ({{unit}})',
                totalLabel: 'Total ({{unit}})',
                damagedLabel: 'Avariado ({{unit}})',
                addExtra: 'Adicionar outro peso',
                removeExtra: 'Remover',
                summaryVolumes: 'Volumes',
                summaryChecked: 'Conferido',
                summaryStock: 'No estoque',
                diffEqual: 'Igual ao previsto. Fica ok para o aceite.',
                diffEqualShort: 'Igual ao previsto',
                diffLess: '{{value}} a menos que o previsto. Fica como divergência para o aceite.',
                diffLessShort: '{{value}} a menos que o previsto',
                diffMore: '{{value}} a mais que o previsto. Os volumes ficam guardados até o aceite.',
                diffMoreShort: '{{value}} a mais que o previsto',
                applyEmpty: 'Informe ao menos um volume.',
                cancel: 'Cancelar',
                apply: 'Aplicar',
                quantityPromptTitle: 'Informar valor',
                volumeCount: '{{count}} volumes',
                volumeCountOne: '1 volume',
                materializing: 'Gerando volumes…',
                materializeError: 'Não foi possível gerar os volumes.',
                generated: '{{count}} volumes gerados',
                generatedOne: '1 volume gerado',
                held: '{{count}} itens aguardam o aceite da divergência',
                heldOne: '1 item aguarda o aceite da divergência',
                printViaReceiving: 'As etiquetas saem pelo recebimento ou pela estação.',
            },
        },
        // Request 0205 — apontamento de produção (bipar + quantidade + execução, Fase B1;
        // modo Parada de máquina, Fase B2).
        productionReport: {
            title: 'Apontar produção',
            modeEntry: 'Apontamento',
            modeStop: 'Parada',
            scanLabelTicketOnly: 'Talão',
            scanLabelTicketOrOrder: 'Talão ou ordem',
            scanPlaceholder: 'Bipe ou digite o código',
            newSearch: 'Nova busca',
            change: 'Trocar',
            loading: 'Carregando…',
            genericError: 'Não foi possível concluir a ação.',
            invalidQuantity: 'Informe uma quantidade válida.',
            quantityLabel: 'Quantidade',
            confirmButton: 'Confirmar',
            pointedOfPlanned: 'Já apontado: {{pointed}} de {{planned}}',
            statusLabel: 'Status: {{status}}',
            orderStatus: {
                draft: 'Rascunho',
                released: 'Liberada',
                'in-progress': 'Em andamento',
                completed: 'Concluída',
                cancelled: 'Cancelada',
            },
            ticketStatus: {
                open: 'Aberto',
                'in-progress': 'Em andamento',
                done: 'Concluído',
                cancelled: 'Cancelado',
            },
            executionContextTitle: 'Contexto da execução',
            executionSummary: 'Etapa {{step}} · Máquina {{machine}} · {{operator}}',
            stepLabel: 'Etapa',
            machineLabel: 'Máquina',
            operatorLabel: 'Operador',
            noStep: 'Nenhuma',
            noMachine: 'Opcional',
            noOperator: 'Quem está digitando',
            stepWithProcess: 'Etapa {{order}} — {{process}}',
            stepOnly: 'Etapa {{order}}',
            selectStepToStart: 'Selecione a etapa para iniciar.',
            noStepsWarning: 'Esta organização exige etapa no apontamento.',
            requireRunWarning: 'Esta organização exige execução iniciada para apontar.',
            startButton: 'Iniciar',
            runningLabel: 'Em execução',
            pausedLabel: 'Parado',
            stopButton: 'Parar',
            resumeButton: 'Retomar',
            finishButton: 'Finalizar',
            concurrentWarning: 'Já existe execução aberta desde {{startedAt}}. Isso não impede iniciar outra.',
            resumeOther: 'Retomar',
            startAnother: 'Iniciar outra',
            stopSheetTitle: 'Parar',
            stopReasonLabel: 'Motivo',
            stopReasonOptionalLabel: 'Motivo (opcional)',
            stopReasonNone: 'Sem motivo',
            notesLabel: 'Observação',
            confirmStopButton: 'Parar',
            sessionTitle: 'Nesta sessão ({{count}})',
            sessionEmpty: 'Nenhum apontamento nesta sessão ainda.',
            sessionEntryLine: '{{quantity}} em {{label}}',
            toastSuccess: '{{quantity}} un em {{label}}',
            toastPending: 'Apontamento gravado. Estoque pendente.',
            toastStartSuccess: 'Execução iniciada.',
            toastFinishSuccess: 'Execução encerrada.',
            toastStopSuccess: 'Parada registrada.',
            toastResumeSuccess: 'Produção retomada.',
            machineStop: {
                scanLabel: 'Máquina',
                scanPlaceholder: 'Bipe ou digite o código da máquina',
                codeLabel: 'Código {{code}}',
                runWarning: 'Esta máquina está executando a OP «{{order}}». A parada vai pausar essa execução.',
                stopButton: 'Parar máquina',
                stoppedLabel: 'Parada',
                resumeButton: 'Retomar máquina',
                toastStopped: 'Máquina parada.',
                toastPaused: 'Execução pausada.',
                toastResumed: 'Máquina retomada.',
            },
        },
        // Request 0334 — consulta de saldo (só leitura).
        stockBalance: {
            scanLabel: 'Produto',
            scanPlaceholder: 'Bipe ou digite o código',
            productNotFound: 'Produto não encontrado',
            genericError: 'Não foi possível consultar o saldo.',
            loading: 'Carregando…',
            totalBalance: 'Saldo total',
            available: 'Disponível',
            reservedAvailable: 'Reservado {{reserved}} · Disponível {{available}}',
            availableOnly: 'Disponível {{available}}',
            lotLine: 'Lote {{lot}}',
            noLots: 'Nenhum lote neste local.',
            emptyBalances: 'Sem saldo para este produto',
            owner: 'Proprietário: {{name}}',
            noVariant: 'Sem variante',
        },
        // Request 0334 — consulta de volume (só leitura).
        handlingUnit: {
            scanLabel: 'Volume',
            scanPlaceholder: 'Bipe ou digite o código da etiqueta',
            volumeNotFound: 'Volume não encontrado',
            loading: 'Carregando…',
            genericError: 'Não foi possível consultar o volume.',
            quantity: 'Quantidade',
            address: 'Endereço',
            noAddress: 'Sem endereço',
            location: 'Local',
            entryDate: 'Entrada',
            variant: 'Variante {{label}}',
            lot: 'Lote {{label}}',
            history: 'Histórico',
            historyEmpty: 'Nenhum movimento registrado.',
            fromTo: '{{from}} → {{to}}',
            quantityMeta: 'Qtd {{quantity}}',
            userMeta: '{{name}}',
        },
    },
};
//# sourceMappingURL=pt-BR.js.map